/**
 * Component Registry for The Jax
 * 
 * Inherits from @vibesites-axia-residential-arc-living/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-axia-residential-arc-living/theme-preferred/registry';
import { Hero } from './components/Hero';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Property-level Hero override: hardcodes the marketing hero video URL so
  // it survives regeneration of the auto-generated property data file.
  Hero,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
